module.exports = __webpack_public_path__ + "img/第6档.d8b5a7fa.png";